import { getSeconds } from "./time";
import { getRandomNumber } from "./util";
import { isFromAd } from "./document";

export const getGoogleAnalyticsClientId = () => {
  const match = document.cookie.match("(?:^|;)\\s*_ga=([^;]*)");
  const raw = match ? decodeURIComponent(match[1]) : null;

  if (raw) {
    const match = raw.match(/(\d+\.\d+)$/);
    const gacid = match ? match[1] : undefined;
    return gacid;
  }

  return undefined;
};

export const getVid = (visitId, counterId) => {
  if (visitId !== 0) {
    return visitId;
  }

  const generateNew = isFromAd();
  let vid = generateNew ? 0 : readM("vid", counterId);

  if (!vid) {
    vid = `${getSeconds()}${getRandomNumber()}`;
  }
  create("vid", counterId, vid, 30);

  return vid;
};

export const getUid = (counterId) => {
  let uid = readM("uid", counterId);
  const uidLS = readLocalStorage("uid", counterId);

  if (!uid && !uidLS) {
    uid = `${getSeconds()}${getRandomNumber()}`;
    create("uid", uid, 1036800);
    createLocalStorage("uid", counterId, uid);
  } else if (!uid && uidLS) {
    uid = uidLS;
    create("uid", uidLS, 1036800);
  } else if (uid && !uidLS) {
    createLocalStorage("uid", counterId, uid);
  }

  return uid;
};

export const getXsollauid = (id, counterId) => {
  const xid = readM("xsollauid", counterId);
  const xidLS = readLocalStorage("xsollauid", counterId);

  if (!id) {
    if (xid && !xidLS) {
      createLocalStorage("xsollauid", counterId, xid);
    } else if (!xid && xidLS) {
      create("xsollauid", counterId, xidLS, 5184000);
    }

    return xid || xidLS;
  }

  create("xsollauid", counterId, id, 5184000);
  createLocalStorage("xsollauid", counterId, id);

  return id;
};

export const createLocalStorage = (name, counterId, value) => {
  try {
    localStorage.setItem(
      prepareName(name, counterId),
      encodeURIComponent(value)
    );
  } catch (e) {}
};

export const create = (name, counterId, value, minutes) => {
  let b,
    a = [prepareName(name, counterId) + "\x3d" + encodeURIComponent(value)];
  const domain = window.location.hostname;

  if (minutes) {
    b = new Date();
    b.setTime(b.getTime() + 6e4 * minutes);
    a.push("expires\x3d" + b.toGMTString());
  }

  domain && a.push("domain\x3d" + domain);
  a.push("path\x3d/");
  a.push("SameSite\x3dNone;Secure");

  try {
    document.cookie = a.join(";");
  } catch (d) {}
};

export const readM = (name, counterId) => {
  name = prepareName(name, counterId);
  return read(name);
};

export const read = (name) => {
  const b = document.cookie;

  return b && b.match(new RegExp("(?:^|;\\s*)" + name + "\x3d([^;]*)"))
    ? decodeURIComponent(RegExp.$1)
    : null;
};

export const readLocalStorage = (name, counterId) => {
  name = prepareName(name, counterId);

  try {
    return localStorage.getItem(name);
  } catch (d) {
    return null;
  }
};

export const erase = (name, counterId) => {
  create(name, counterId, "", -1);
};

export const prepareName = (name, counterId) => {
  if (name === "xsollauid") {
    return name;
  }

  return `_mm_${name}${counterId ? `_${counterId}` : ""}`;
};
